var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRlc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.49 5.245a4.245 4.245 0 1 1-8.49 0 4.245 4.245 0 0 1 8.49 0zm0 10.755a4.245 4.245 0 1 1-1.748-3.434c.744-.073 1.425-.164 1.607-.316.201-.169.464-.68.703-1.147l.039-.075a4.245 4.245 0 1 1 1.778 2.933c-.713.1-1.536.277-1.813.554-.258.258-.45.79-.572 1.26.004.075.006.15.006.226zM7.246 31a4.245 4.245 0 0 0 4.24-4.472c.122-.47.314-1.001.572-1.26.277-.276 1.1-.454 1.813-.552a4.245 4.245 0 0 0 6.671-3.706c.122-.47.314-1.001.572-1.26.223-.223.8-.382 1.389-.486a4.245 4.245 0 1 0-1.496-2.722c-.21.403-.427.8-.6.944-.183.152-.863.243-1.607.316a4.245 4.245 0 0 0-6.707 3.981l-.04.076c-.239.466-.502.978-.704 1.147-.183.152-.864.243-1.608.316A4.245 4.245 0 1 0 7.245 31z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRlc);
export default __webpack_public_path__ + "static/media/RLC.07c5a8598c46eb9f2c73ac12248eb2ba.svg";
export { ForwardRef as ReactComponent };